import React from 'react';
import { Link } from 'react-router-dom';
import { DownloadCloud, Youtube, MessageCircle, Home, Play, FileText } from 'lucide-react';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-[#0a0014] bg-[radial-gradient(ellipse_at_top,rgba(121,40,202,0.15),rgba(0,0,0,0.4))]">
      <div className="fixed inset-0 bg-grid opacity-25 pointer-events-none" />
      <div className="fixed inset-0 bg-gradient-to-b from-transparent via-purple-900/5 to-black/20 pointer-events-none" />
      <nav className="fixed w-full bg-black/40 backdrop-blur-xl border-b border-purple-500/10 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold text-white hover:text-purple-400 transition-colors">
              Synapse X Remake
            </Link>
            <div className="flex items-center gap-8 text-white">
              <Link to="/" className="flex items-center gap-2 hover:text-purple-400 transition-all hover:scale-105">
                <Home className="w-4 h-4" />
                <span>Home</span>
              </Link>
              <Link to="/showcase" className="flex items-center gap-2 hover:text-purple-400 transition-all hover:scale-105">
                <Play className="w-4 h-4" />
                <span>Showcase</span>
              </Link>
              <Link to="/tos" className="flex items-center gap-2 hover:text-purple-400 transition-all hover:scale-105">
                <FileText className="w-4 h-4" />
                <span>Terms</span>
              </Link>
              <a 
                href="https://discord.gg/synapsexremake" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-gradient-to-r from-purple-600 to-fuchsia-600 px-4 py-2 rounded-lg transition-all hover:scale-105 hover:shadow-[0_0_20px_rgba(168,85,247,0.4)] shadow-[0_0_15px_rgba(168,85,247,0.2)]"
              >
                <MessageCircle className="w-4 h-4" />
                <span>Join Discord</span>
              </a>
            </div>
          </div>
        </div>
      </nav>
      <main className="pt-16 relative z-10">
        {children}
      </main>
      <footer className="bg-black/40 backdrop-blur-xl border-t border-purple-500/10 py-8 relative z-10">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-white">
            <div>
              <h3 className="text-lg font-semibold mb-4">Synapse X Remake</h3>
              <p className="text-gray-400">The most powerful script utility available.</p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-gray-400 hover:text-purple-400 transition-colors">Home</Link>
                <Link to="/showcase" className="text-gray-400 hover:text-purple-400 transition-colors">Showcase</Link>
                <Link to="/tos" className="text-gray-400 hover:text-purple-400 transition-colors">Terms of Service</Link>
              </div>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Connect</h3>
              <div className="flex gap-4">
                <a href="https://discord.gg/synapsexremake" target="_blank" rel="noopener noreferrer" 
                   className="text-gray-400 hover:text-purple-400 transition-all hover:scale-110">
                  <MessageCircle className="w-6 h-6" />
                </a>
                <a href="https://www.youtube.com/@Forlornicus/videos" target="_blank" rel="noopener noreferrer" 
                   className="text-gray-400 hover:text-purple-400 transition-all hover:scale-110">
                  <Youtube className="w-6 h-6" />
                </a>
              </div>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-purple-500/10 text-center text-gray-400">
            <p>&copy; {new Date().getFullYear()} Synapse X Remake. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}